<template lang="jade">
  div.Notices
    div.Notices__item.animated(v-for="notice in notices"
                               transition="fadeInOutRight")
      notice(":icon"="icons[notice.type]"
             ":state"="states[notice.type]"
             ":notice.sync"="notice")
</template>
<script>
  import _ from 'lodash'
  import { notifications, skins } from 'src/vuex/getters.js'
  import notice from './notice'

  export default {
    data () {
      return {
        states: {
          error: ['Notice--error'],
          info: ['Notice--info']
        },
        icons: {
          error: ['Notice__icon--error'],
          info: ['Notice__icon--info']
        }
      }
    },
    vuex: {
      getters: {
        skins,
        notifications
      }
    },
    computed: {
      notices () {
        return _.filter(this.notifications, x => x.show)
      }
    },
    components: {
      notice
    }
  }
</script>



// WEBPACK FOOTER //
// notifications.vue?7929586b